import React from 'react';
import { Container, makeStyles, Button, Grid, Box, CircularProgress } from '@material-ui/core';
import {
  BackNavAdmin,
  ArticleCard,
} from '../../components';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { articleActions } from '../../actions';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SkeletonChallengeCard } from '../../components/Skeletons';
import { EmptyState } from '../../components/Shared';
import { portfolioIcon } from '../../assets/imgs';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: theme.spacing(4),
  },
  btnNewArticle: {
    float: 'right',
    padding: theme.spacing(1, 2),
  },
}));

function ArticlesPage() {
  const classes = useStyles();
  const { articles, loading, paging } = useSelector((state) => state.articlesReducer);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(articleActions.clear());
    dispatch(articleActions.getArticles(paging.page, paging.sort, paging.limit, paging.searchText));
  }, [dispatch,]);

  useEffect(() => {
    if (!loading) {
      dispatch(articleActions.getArticles(paging.page, paging.sort, paging.limit, paging.searchText));
    }
  }, [dispatch]);

  function loadMoreArticles() {
    if (!loading) {
      dispatch(articleActions.getMoreArticles(paging.page, paging.sort, paging.limit, paging.searchText));
    }
  }

  return (
    <>
      <BackNavAdmin title={!loading ? t('artigos') : t('carregando')} pathname="/">
        <Button
          className={classes.btnNewArticle}
          variant="contained"
          color="primary"
          type="submit"
          startIcon={<AddCircleIcon />}
          component={Link}
          to="/article/new"
        >
          {t('novo_artigo')}
        </Button>
      </BackNavAdmin>
      <Container maxWidth="lg" className={classes.root}>
        <Grid container spacing={2}>
          <Grid item xs={12} >
            {loading ? (
              <Box display="flex" justifyContent="center" alignItems="center" width="100%" height="60vh">
                <CircularProgress />
              </Box>
            ) : (
              <>
                {articles.length > 0 ? (
                  <InfiniteScroll
                    dataLength={articles.length}
                    next={loadMoreArticles}
                    hasMore={true}
                    scrollThreshold={'90%'}
                    style={{ overflow: 'hidden', paddingBottom: 20 }}
                  >
                    <Grid container spacing={2}>
                      {articles.map((article) => (
                        <Grid item xs={12} sm={6} md={4} lg={3} key={article._id}>
                          <ArticleCard
                            title={article.title}
                            description={article.description}
                            link={`/article/detail/${article._id}`}
                            image={article.thumbnail?.url || ""}
                          />
                        </Grid>
                      ))}
                    </Grid>
                  </InfiniteScroll>
                ) : (
                  <Box marginTop="2rem">
                    <EmptyState
                      icon={portfolioIcon}
                      description={t('ainda_nao_ha_artigos_publicados')}
                    />
                  </Box>
                )}
              </>
            )}
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export { ArticlesPage };
